import type { Geometry, Position } from 'geojson';

/** Ray casting по одному кольцу полигона. */
export function isPointInRing([x, y]: Position, ring: Position[]): boolean {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) inside = !inside;
  }
  return inside;
}

/** Точка внутри (Multi)Polygon с учётом дыр; для прочих геометрий - false. */
export function isPointInGeometry(point: Position, geometry: Geometry): boolean {
  const polygons =
    geometry.type === 'Polygon'
      ? [geometry.coordinates]
      : geometry.type === 'MultiPolygon'
        ? geometry.coordinates
        : [];
  return polygons.some(
    ([outer, ...holes]) =>
      outer != null && isPointInRing(point, outer) && !holes.some(hole => isPointInRing(point, hole)),
  );
}
